module.exports = __webpack_public_path__ + "img/7.2082d6db.jpg";